import { EOSService } from "../../api/eos-service";
import { SectionsService } from "../../api/sections-service";

const state = {
};

const getters = {};

const actions = {
    async GetAdminSectionDegree(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params['perno'] = perno;
        return await EOSService.makeRequest(SectionsService.GetAdminSectionDegree(params))
    },
    /**
         * @params
         * accessTo
         * adminPerno
         */
    async GetSectionsList(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params.append('adminPerno', perno);
        return await EOSService.makeRequest(SectionsService.GetSectionsList(params))
    },
    async GetAdmins() {
        return await EOSService.makeRequest(SectionsService.GetAdmins())
    },
    async GetAllSections() {
        return await EOSService.makeRequest(SectionsService.GetAllSections())
    },
    async GetSectionsForManager(context) {
        var params = new URLSearchParams();
        var perno = context.rootState.auth.auth.username;
        params.append('perno', perno);
        return await EOSService.makeRequest(SectionsService.GetSectionsForManager(params))
    },
    async GetAllSectionsForManager(context) {
        var params = new URLSearchParams();
        var perno = context.rootState.auth.auth.username;
        params.append('perno', perno);
        return await EOSService.makeRequest(SectionsService.GetAllSectionsForManager(params))
    },
    async GetDedicatedSectionForPersentPessonel(context) {
        var params = new URLSearchParams();
        var perno = context.rootState.auth.auth.username;
        params.append('perno', perno);
        return await EOSService.makeRequest(SectionsService.GetDedicatedSectionForPersentPessonel(params))
    },
    async CanChangePersonPermission(context, { perno, section }) {
        var params = new URLSearchParams()
        params.append('perno', perno)
        params.append('section', section)
        return await EOSService.makeRequest(SectionsService.CanChangePersonPermission(params))
    },
    async CanResetPersonPassword(context, { perno, section }) {
        var params = new URLSearchParams()
        params.append('perno', perno)
        params.append('section', section)
        return await EOSService.makeRequest(SectionsService.CanResetPersonPassword(params))
    },
    async IsOutOfGroup(context, { perno }) {
        var params = new URLSearchParams()
        params.append('perno', perno)
        return await EOSService.makeRequest(SectionsService.IsOutOfGroup(params))
    },
    async IsDublicatedAdmin(context, { perno, sectionCode }) {
        var params = new URLSearchParams()
        params.append('perno', perno)
        params.append('sectionCode', sectionCode)
        return await EOSService.makeRequest(SectionsService.IsDublicatedAdmin(params))
    },
    async IsExistInAdminList(context, { IsExistInAdminListParams }) {
        var params = new URLSearchParams()
        params.append('perno', IsExistInAdminListParams.perno)
        params.append('sectionCode', IsExistInAdminListParams.sectionCode)
        return await EOSService.makeRequest(SectionsService.IsExistInAdminList(params))
    },
    async AddSectionAdmin(context, { perno, sectionCode }) {
        var params = new URLSearchParams()
        params.append('perno', perno)
        params.append('sectionCode', sectionCode)
        return await EOSService.makeRequest(SectionsService.AddSectionAdmin(params))
    },
    async UpdateSectionAdmin(context, { perno, sectionCode, id }) {
        var params = new URLSearchParams()
        params.append('id', id)
        params.append('perno', perno)
        params.append('sectionCode', sectionCode)
        return await EOSService.makeRequest(SectionsService.UpdateSectionAdmin(params))
    },
    async DeleteSection(context, { sectionCode }) {
        var params = new URLSearchParams()
        params.append('sectionCode', sectionCode)
        return await EOSService.makeRequest(SectionsService.DeleteSection(params))
    },
    async GetAdminSectionCode(context, { perno }) {
        var params = new URLSearchParams()
        params.append('perno', perno)
        return await EOSService.makeRequest(SectionsService.GetAdminSectionCode(params))
    },
    async GetWebSectionsAdmins(context, { sectionid }) {
        var params = new URLSearchParams()
        params.append('sectionid', sectionid)
        return await EOSService.makeRequest(SectionsService.GetWebSectionsAdmins(params))
    },
    async GetWebSectionDetail(context, { sectionid }) {
        var params = new URLSearchParams()
        params.append('sectionid', sectionid)
        return await EOSService.makeRequest(SectionsService.GetWebSectionDetail(params))
    },
    async UpdateWebSectionProperties(context, { UpdateWebSectionParams }) {
        var params = new URLSearchParams()
        params.append('sectionid', UpdateWebSectionParams.sectionid)
        params.append('ismanager', UpdateWebSectionParams.ismanager)
        params.append('adminpermission', UpdateWebSectionParams.adminpermission)
        return await EOSService.makeRequest(SectionsService.UpdateWebSectionProperties(params))
    },
    async findVacationPermission(context, { findVacationPermissionParams }) {
        var params = new URLSearchParams()
        params.append('sectionid', findVacationPermissionParams.sectionid)
        params.append('code', findVacationPermissionParams.code)
        return await EOSService.makeRequest(SectionsService.findVacationPermission(params))
    },
    async findMissionPermission(context, { findMissionPermissionParams }) {
        var params = new URLSearchParams()
        params.append('sectionid', findMissionPermissionParams.sectionid)
        params.append('code', findMissionPermissionParams.code)
        return await EOSService.makeRequest(SectionsService.findMissionPermission(params))
    },
    async findIOPermission(context, { findIOPermissionParams }) {
        var params = new URLSearchParams()
        params.append('sectionid', findIOPermissionParams.sectionid)
        return await EOSService.makeRequest(SectionsService.findIOPermission(params))
    },
    async findExtraWorkPermission(context, { findExtraWorkPermissionParams }) {
        var params = new URLSearchParams()
        params.append('sectionid', findExtraWorkPermissionParams.sectionid)
        return await EOSService.makeRequest(SectionsService.findExtraPermission(params))
    },
    async findSpecificExtraworkPermission(context, { findSpecificExtraworkPermissionParams }) {
        var params = new URLSearchParams()
        params.append('sectionid', findSpecificExtraworkPermissionParams.sectionid)
        return await EOSService.makeRequest(SectionsService.FindSpecificExtraworkPermission(params))
    },
    async AddPatternDetailvacationPermission(context, { AddPatternDetailvacationPermissionParams }) {
        var params = new URLSearchParams()
        params.append('sectionid', AddPatternDetailvacationPermissionParams.sectionid)
        params.append('vacationCode', AddPatternDetailvacationPermissionParams.vacationCode)
        params.append('statusCode', AddPatternDetailvacationPermissionParams.statusCode)
        return await EOSService.makeRequest(SectionsService.AddPatternDetailvacationPermission(params))
    },
    async AddPatternDetailMissionPermission(context, { AddPatternDetailMissionPermissionParams }) {
        var params = new URLSearchParams()
        params.append('sectionid', AddPatternDetailMissionPermissionParams.sectionid)
        params.append('missionCode', AddPatternDetailMissionPermissionParams.missionCode)
        params.append('statusCode', AddPatternDetailMissionPermissionParams.statusCode)
        return await EOSService.makeRequest(SectionsService.AddPatternDetailMissionPermission(params))
    },
    async AddPatternDetailIoPermission(context, { AddPatternDetailIoPermissionParams }) {
        var params = new URLSearchParams()
        params.append('sectionid', AddPatternDetailIoPermissionParams.sectionid)
        params.append('statusCode', AddPatternDetailIoPermissionParams.statusCode)
        return await EOSService.makeRequest(SectionsService.AddPatternDetailIoPermission(params))
    },
    async AddPatternDetailExtraWorkPermission(context, { AddPatternDetailExtraWorkPermissionParams }) {
        var params = new URLSearchParams()
        params.append('sectionid', AddPatternDetailExtraWorkPermissionParams.sectionid)
        params.append('statusCode', AddPatternDetailExtraWorkPermissionParams.statusCode)
        return await EOSService.makeRequest(SectionsService.AddPatternDetailExtraWorkPermission(params))
    },
    async AddWebSectionDetailSpecificExtraWorkPermission(context, { AddWebSectionDetailSpecificExtraWorkPermissionParams }) {
        var params = new URLSearchParams()
        params.append('sectionid', AddWebSectionDetailSpecificExtraWorkPermissionParams.sectionid)
        params.append('statusCode', AddWebSectionDetailSpecificExtraWorkPermissionParams.statusCode)
        return await EOSService.makeRequest(SectionsService.AddWebSectionDetailSpecificExtraWorkPermission(params))
    },
    async DeletePatternDetailPermission(context, { DeletePatternDetailPermissionParams }) {
        var params = new URLSearchParams()
        params.append('sectionid', DeletePatternDetailPermissionParams.sectionid)
        params.append('code', DeletePatternDetailPermissionParams.code)
        params.append('pageKind', DeletePatternDetailPermissionParams.pageKind)
        return await EOSService.makeRequest(SectionsService.DeletePatternDetailPermission(params))
    },
    async findSectionName(context, { data }) {
        var params = new URLSearchParams()
        params.append('sectionCode', data.sectionCode)
        return await EOSService.makeRequest(SectionsService.findSectionName(params))
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}